import useSWR from 'swr';
import { getProfilEndPoint } from '../utils/endpoint';
import useSWRFetcher from '../hooks/useSWRFetcher';

/**
 * @typedef {Object} TechnicalInfo
 * @property {number} bandwidthUp
 * @property {number} bandwidthDown
 * @property {string} browser
 * @property {string} micId
 * @property {string} webcamId
 * @property {string} os
 */

/**
 * @typedef {Object} VideoResults
 * @property {boolean} audioStream
 * @property {boolean} videoStream
 * @property {number} audioVolume
 */

/**
 * @typedef {Object} Profile
 * @property {string} faqUrl
 * @property {string} status
 * @property {Requisites} requisites - the requisites that candidate already upload
 * @property {string} lastName
 * @property {string} email
 * @property {number} expirationDate
 * @property {string} firstName
 * @property {boolean} rescued - only once when candidate is on the exam and need a rescue : on force refresh disable modal for next / last question
 * @property {Object} consents - Eula
 * @property {boolean} needRequisite - to show/disable Requisite template
 * @property {string} returnUrl
 * @property {number | null} timerEnd - remaining time for the exam
 * @property {TechnicalInfo} technicalInformation
 * @property {Object} technicalTest
 * @property {VideoResults} videoResults
 */

/**
 * Fetch to get profile from the actual candidate
 * @returns {{mutate: (data?: (Promise<any> | mutateCallback<any> | any), shouldRevalidate?: boolean) => Promise<any | undefined>, data: Profile, revalidate: () => Promise<boolean>, response: Res<any>, error: any, loading: (boolean|boolean), isValidating: boolean}}
 */
const useProfile = (auth = true) => {
	const get = useSWRFetcher();
	const { data, error, mutate, isValidating } = useSWR(auth ? getProfilEndPoint : null, get);

	const loading = !data && !error;

	return {
		data,
		error,
		loading,
		mutate,

		isValidating,
	};
};

export default useProfile;
